export class FirebaseObject {
  $key: string;
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/firebase/firebase-object.ts